import { render, staticRenderFns } from "./AllowancesPlanAdd.vue?vue&type=template&id=540e3292&scoped=true&"
import script from "./AllowancesPlanAdd.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e3292",
  null
  
)

export default component.exports